import { render } from "./tw-aside.vue?vue&type=template&id=01483ac8"
import script from "./tw-aside.vue?vue&type=script&lang=js"
export * from "./tw-aside.vue?vue&type=script&lang=js"
script.render = render

export default script